export const ranchNftAbi = [
  {
    type: 'function', name: 'mint', stateMutability: 'payable',
    inputs: [{ name: 'quantity', type: 'uint256' }], outputs: []
  },
  {
    type: 'function', name: 'mintPrice', stateMutability: 'view', inputs: [],
    outputs: [{ name: '', type: 'uint256' }]
  },
  {
    type: 'function', name: 'totalMinted', stateMutability: 'view', inputs: [],
    outputs: [{ name: '', type: 'uint256' }]
  },
  {
    type: 'function', name: 'maxSupply', stateMutability: 'view', inputs: [],
    outputs: [{ name: '', type: 'uint256' }]
  },
  {
    type: 'function', name: 'saleActive', stateMutability: 'view', inputs: [],
    outputs: [{ name: '', type: 'bool' }]
  },
  {
    type: 'function', name: 'balanceOf', stateMutability: 'view',
    inputs: [{ name: 'owner', type: 'address' }], outputs: [{ name: '', type: 'uint256' }]
  },
  {
    type: 'function', name: 'rewardToken', stateMutability: 'view', inputs: [],
    outputs: [{ name: '', type: 'address' }]
  },
  {
    type: 'function', name: 'rewardPerNft', stateMutability: 'view', inputs: [],
    outputs: [{ name: '', type: 'uint256' }]
  }
] as const;
